// Slick Carousel
import Glide from "@glidejs/glide";

class CarouselHeroCaption {
  constructor() {
    // element that will be wrapped
    const carousel = document.querySelector(".carousel-hero-caption");

    // If the carousel is not present on this page, bail early
    if (!carousel) {
      return;
    }

    // Safe to touch styles now
    carousel.style.backgroundColor = "#000"; // Set background color of carousel to black

    const carouselTrack = carousel.querySelector(
      ".wp-block-group"
    );

    // If the expected inner structure is missing, bail early
    if (!carouselTrack) {
      return;
    }

    const carouselSlides = carouselTrack.querySelector(
      ":scope > .wp-block-group"
    );

    if (!carouselSlides) {
      return;
    }

    const carouselIndividualSlide = carouselSlides.querySelectorAll(
      ".wp-block-cover"
    );

    if (!carouselIndividualSlide.length) {
      return;
    }

    // Add Glide classes
    carouselTrack.classList.add("glide__track");
    carouselTrack.dataset.glideEl = "track";
    carouselSlides.classList.add("glide__slides");
    carouselIndividualSlide.forEach((item) => {
      item.classList.add("glide__slide");
      item.style.transition = "opacity 1s"; // Add transition style
    });

    // Tweak styles
    carousel.style.overflow = "hidden";
    carouselSlides.style.flexWrap = "nowrap";

    var fullWidthGlide = new Glide(".carousel-hero-caption", {
      type: "carousel",
      perView: 1,
      autoplay: 3000,
      peek: 0,
      gap: 0,
      animationDuration: 10,
      swipeThreshold: 10,
    }).mount();

    // Adjust opacity of slides
    fullWidthGlide.on("move", function () {
      carouselIndividualSlide.forEach((item) => {
        item.style.opacity = 0.1;
      });
    });

    fullWidthGlide.on("move.after", function () {
      const current = carouselIndividualSlide[fullWidthGlide.index];
      if (current) current.style.opacity = 1;
    });
  }
}

export default CarouselHeroCaption;
